import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { add_effects, update_effects } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';

export const EffectsForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData } = useContext(NewContext);
    const [effects, setEffects] = useState({
        name: state ? state.name : "",
        isPremium: state ? state.isPremium == undefined ? false : state.isPremium : false,
        // isActive: state ? state.isActive == undefined ? false : state.isActive : false,
    });
    const [imgObj, setImgObj] = useState({ effectPreview: state ? state.preview : "" });

    const handleChange = (e) => {
        // if (e.target.name === 'effectsCategory' || e.target.name === "effectsTag") {
        //     let effectsCategoryAry = [].slice.call(e.target.selectedOptions).map(item => item.value);
        //     setEffects({ ...effects, [e.target.name]: effectsCategoryAry });
        // } else {
        setUpdatedData({ ...updatedData, [e.target.name]: e.target.value });
        setEffects({ ...effects, [e.target.name]: e.target.value });
        // }
    };

    const handleFileInput = (e) => {
        if (e.target.files[0].size > 5242880) {
            toast.error(`${e.target.name.charAt(0).toUpperCase() + e.target.name.slice(1)} must less than 5 MB!`);
        } else {
            setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
            setUpdatedData({ ...updatedData, [e.target.name]: e.target.files[0] })
            setEffects({ ...effects, [e.target.name]: e.target.files[0] });
        }
    };

    let handleSwitch = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: effects[e.target.name] ? false : true });
        setEffects({ ...effects, [e.target.name]: effects[e.target.name] ? false : true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        };
        let createUpdateEffects;
        setIsLoading(true);
        if (state) {
            createUpdateEffects = await update_effects(updatedData, state._id)
        } else {
            // console.log("==========effects==========", effects);
            createUpdateEffects = await add_effects(effects)
        }
        setIsLoading(false);
        if (createUpdateEffects) {
            const { message, status } = createUpdateEffects;
            if (status) {
                toast.success(message);
                navigate("/effects");
                setEffects({
                    name: "",
                    isPremium: false,
                    isActive: false,
                });
                setImgObj({ effectPreview: "" });
                setUpdatedData({});
                setValidated(false);
            } else {
                toast.error(message);
            };
        }

        // var allFieldDone = [];
        // Object.keys(effects).map(async (fieldName, i) => {
        //     if (fieldName !== 'id') {
        //         if (effects[fieldName].toString().length > 0) {
        //             if (fieldName === "effectZip") {
        //                 if (effects.effectZip.type.split('/')[1] !== 'x-zip-compressed') {
        //                     allFieldDone.push(false);
        //                     toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is must be a zip file!!`);
        //                 } else {
        //                     allFieldDone.push(true);
        //                 }
        //             } else {
        //                 allFieldDone.push(true);
        //             }
        //         } else {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //         }
        //     }
        // });
        // if (!state) {
        //     Object.keys(imgObj).map(async (fieldName, i) => {
        //         if (!imgObj[fieldName]) {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //             return allFieldDone;
        //         } else {
        //             allFieldDone.push(true);
        //         }
        //     });
        // }

        // const aalFieldDone = allFieldDone.every((val, i, arr) => val === true)
        // if (aalFieldDone) {
        //     let createUpdateEffects;
        //     setIsLoading(true);
        //     if (state) {
        //         createUpdateEffects = await update_effects(effects, state._id)
        //     } else {
        //         // console.log("==========effects==========", effects);
        //         createUpdateEffects = await add_effects(effects)
        //     }
        //     setIsLoading(false);
        //     if (createUpdateEffects) {
        //         const { message, status } = createUpdateEffects;
        //         if (status) {
        //             toast.success(message);
        //             navigate("/effects");
        //             setEffects({
        //                 id: "",
        //                 name: "",
        //                 isPremium: false,
        //                 isActive: false,
        //             });
        //             setImgObj({ effectPreview: "" });
        //         } else {
        //             toast.error(message);
        //         };
        //     }
        // }
    };

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit Effects` : `Add Effects`}</h3>
            </div>
            <Row>
                <Col lg={3} md={4} sm={6} className="mb-3 mx-auto">
                    <Row className='flex-column'>
                        <Col className='mb-3'>
                            <h6 className='mb-1'>Preview : </h6>
                            <img className='w-100' src={`${imgObj.effectPreview ? imgObj.effectPreview : `../../../assets/images/no-image.png`}`} alt={effects.name} />
                        </Col>
                    </Row>
                </Col>
                <Col md={8} lg={9}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='effects_name' column md={3} sm={4}>Name</Form.Label>
                                    <Col><Form.Control id='effects_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : effects.name} required /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='effects_effectPreview' column md={3} sm={4}>Preview</Form.Label>
                                    <Col><Form.Control id='effects_effectPreview' type="file" accept='image/*' name='effectPreview' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='effects_effectZipxhdpi' column md={3} sm={4}>Effect X Zip</Form.Label>
                                    <Col><Form.Control id='effects_effectZipxhdpi' type="file" name='effectZipxhdpi' accept='application/x-zip-compressed' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='effects_effectZipxxhdpi' column md={3} sm={4}>Effect XX Zip</Form.Label>
                                    <Col><Form.Control id='effects_effectZipxxhdpi' type="file" name='effectZipxxhdpi' accept='application/x-zip-compressed' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='effects_effectZipxxxhdpi' column md={3} sm={4}>Effect XXX Zip</Form.Label>
                                    <Col><Form.Control id='effects_effectZipxxxhdpi' type="file" name='effectZipxxxhdpi' accept='application/x-zip-compressed' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='effects_isPremium' column md={3} sm={4}>Premium</Form.Label>
                                    <Col><Form.Check type="switch" id="effects_isPremium" name='isPremium' onChange={handleSwitch} checked={updatedData.isPremium ? updatedData.isPremium : effects.isPremium} role="button" /></Col>
                            </Col>
                            {/* <Col lg={6} className="mb-3">
                                <Row className='align-items-center'>
                                    <Form.Label htmlFor='effects_isActive' column md={3} sm={4}>Active</Form.Label>
                                    <Col><Form.Check type="switch" id="effects_isActive" name='isActive' onChange={handleSwitch} checked={effects.isActive} role="button" /></Col>
                                </Row>
                            </Col> */}
                        </Row>
                        <Row className='justify-content-end'>
                            <Col lg={12}>
                                    <Col lg={3} md={3} sm={4}></Col>
                                    <Col>
                                        <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                                            {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                        </Button>
                                        {/* <Link to=""> */}
                                        <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                                        {/* </Link> */}
                                    </Col>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

EffectsForm.defaultProps = {
    title: "Effects Form"
};

export default EffectsForm;